import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { MateriasTab } from './components/materias-tab';
import { UsuariosTab } from './components/usuarios-tab';
import { GeralTab } from './components/geral-tab';

export function ConfiguracoesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Configurações</h1>
        <p className="text-sm text-muted-foreground">Dados de referência da unidade.</p>
      </div>

      <Tabs defaultValue="geral">
        <TabsList>
          <TabsTrigger value="geral">Geral</TabsTrigger>
          <TabsTrigger value="materias">Matérias e conteúdos</TabsTrigger>
          <TabsTrigger value="usuarios">Usuários</TabsTrigger>
        </TabsList>
        <TabsContent value="geral" className="mt-4">
          <GeralTab />
        </TabsContent>
        <TabsContent value="materias" className="mt-4">
          <MateriasTab />
        </TabsContent>
        <TabsContent value="usuarios" className="mt-4">
          <UsuariosTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
